import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AdminFormValues } from "src/models/User.model";
import ATMPassword from "src/components/UI/atoms/formFields/ATMPassword/ATMPassword";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useUserRole from "src/hooks/useUserRole";

type Props = {
  formikProps: FormikProps<AdminFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const AdminForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { isDataLoading, userRole } = useUserRole();
  const RoleOptions = userRole?.map((userRole: any) => {
    return {
      label: userRole?.roleName,
      value: userRole?._id,
    };
  });
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Admin" : "Update Admin"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="name"
            value={values.name}
            required
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            label=" Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="mobile"
            value={values.mobile}
            required
            onChange={(e) => {
              setFieldValue("mobile", e.target.value);
            }}
            label="Mobile"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="email"
            value={values.email}
            required
            onChange={(e) => {
              setFieldValue("email", e.target.value);
            }}
            label="Email"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMSelect
            required
            name="roleId"
            placeholder="Select role"
            label="User Role"
            options={RoleOptions}
            isLoading={isDataLoading}
            onChange={(newValue: any) => {
              setFieldValue("roleId", newValue);
            }}
            value={values?.roleId}
          />
        </div>
        {formType === "ADD" && (
          <div>
            <ATMTextField
              required
              name="password"
              placeholder="Enter Password"
              value={values?.password || ""}
              onChange={(e) => {
                setFieldValue("password", e.target.value);
              }}
              label="Password"
              onBlur={handleBlur}
            />
          </div>
        )}
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AdminForm;
